import FileManagement from '@components/file-management';
import OperationHistoryFilter from '@components/filters/operation-history';
import { ROUTES } from 'constants/routes';
import { operationHistoryExternalDeliveryFilesListColumns } from './list-data';
import { useEffect, useState } from 'react';

import { Classification, DepartmentCode } from 'types';
import { getExternalDeliveryDownloadList } from 'shared/helpers/operation-history/get-external-delivery-download-list';
import { useLocation, useNavigate } from 'react-router-dom';
import { checkPayloadObject } from 'shared/helpers/checkPayloadObject';

type listDataType = {
  page: number;
  size: number;
  sortName: string;
  sortType: string;
  schGroup: string;
  schKeyword: string;
  adminConfigEnv: {
    cssJsVersion: string;
  } | null;
  shmHistDownloadList:
  | [
    {
      fileTotalCnt: number;
      fileTotalSize: number;
      histDt: string;
      histSeq: string;
      remoteIp: string;
      shmDeptCd: DepartmentCode;
      shmLfsKind: Classification;
      shmSubject: string;
    },
  ]
  | [];
  totalCount: number;
};

const ExternalDeliveryDownloadFilesPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [isLoading, setLoading] = useState<boolean>(false)
  const initialData: listDataType = {
    page: 1,
    size: 10,
    sortName: '',
    sortType: '',
    schGroup: '',
    schKeyword: '',
    adminConfigEnv: null,
    shmHistDownloadList: [],
    totalCount: 0,
  }
  const [listData, setListData] = useState<listDataType>(initialData);

  useEffect(() => {
    const isRefresh = location?.state?.refresh
    const fetchData = async () => {
      setLoading(true)
      // @ts-ignore
      await getExternalDeliveryDownloadList(initialData,
        // @ts-ignore
        [{ key: 'page', value: 1 }, { key: 'schGroup', value: 'subject_filename' }, { key: 'schKeyword', value: '' }],
        setListData,
        ['page', 'schGroup', 'schKeyword'])
      setLoading(false)
    }

    if (isRefresh) {
      fetchData()
    }
  }, [location?.state])


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      await getExternalDeliveryDownloadList(listData, [], setListData, []);
      setLoading(false)
    }
    fetchData()
  }, []);

  return (
    <FileManagement
      title="외부 링크용 파일 다운로드"
      linkStack={[
        {
          label: 'Home',
          path: ROUTES.OPERATION_HISTORY.EXTERNAL_DELIVERY_DOWNLOAD_FILES.path,
        },
        {
          label: '운영 이력',
          path: ROUTES.OPERATION_HISTORY.EXTERNAL_DELIVERY_DOWNLOAD_FILES.path,
        },
        {
          label: '외부 링크용 파일 다운로드',
          path: ROUTES.OPERATION_HISTORY.EXTERNAL_DELIVERY_DOWNLOAD_FILES.path,
        },
      ]}
      Filter={
        <OperationHistoryFilter
          isLoading={isLoading}
          getFilteredList={async (payload) => {
            setLoading(true)
            await getExternalDeliveryDownloadList(listData, payload, setListData, [
              'page',
              'schGroup',
              'schKeyword',
            ])
            if (!checkPayloadObject(payload)) {
              navigate(
                ROUTES.OPERATION_HISTORY.EXTERNAL_DELIVERY_DOWNLOAD_FILES.path,
                { state: { page: payload[0].value, notEmpty: true } }
              )
            }
            setLoading(false)
          }}
        />
      }
      isLoading={isLoading}
      isCreateAction={false}
      type={{
        root: 'OPERATION_HISTORY',
        children: {
          EXTERNAL_DELIVERY_DOWNLOAD_FILES: 'EXTERNAL_DELIVERY_DOWNLOAD_FILES',
        },
      }}
      listData={{
        columns: operationHistoryExternalDeliveryFilesListColumns,
        rows: listData?.shmHistDownloadList?.map((item, index) => {
          return {
            id:
              listData.totalCount - listData.size * (listData.page - 1) - index,
            ...item,
          };
        }),
        totalCount: listData.totalCount,
        page: listData.page,
        pageSize: listData.size,
      }}
      getFilteredList={(payload) =>
        getExternalDeliveryDownloadList(listData, payload, setListData, [
          'sortName',
          'sortType',
        ])
      }
      handlePagination={async (payload) => {
        await getExternalDeliveryDownloadList(listData, payload, setListData, [
          'page',
        ])
        if (!checkPayloadObject(payload)) {
          navigate(
            ROUTES.OPERATION_HISTORY.EXTERNAL_DELIVERY_DOWNLOAD_FILES.path,
            { state: { page: payload[0].value, notEmpty: true } }
          )
        }
      }}
    />
  );
};

export default ExternalDeliveryDownloadFilesPage;
